export async function getApiErrorMessage(response) {
  try {
    const body = await response.json();
    return body?.message || body?.error || body?.errors?.[0]?.message || null;
  } catch {
    return null;
  }
}

